<template>
  <v-card class="close-out input-card">
    <v-tabs v-model="tab"
            grow
            show-arrows>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#details">Close Out Details</v-tab>
      <v-tab href="#documents">Documents</v-tab>
      <v-tab href="#downloads">Download</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="details">
        <v-container class="input-wrapper" pa-0>
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="5" sm="4" md="4" lg="4" xl="4" cols="5">
              <v-menu v-model="calendarA"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                <v-date-picker v-model="DCMP" @input="calendarA = false"></v-date-picker>
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="DCMP" label="DCMP" readonly v-on="on"></v-text-field>
                </template>
              </v-menu>
            </v-col>
            <v-col xs="5" sm="4" md="4" lg="4" xl="4" cols="5">
              <v-text-field :rules="[rules.number]" label="CPA" v-model.number="CPA" type="number"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="documents">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="document" ref="saveDocs" step="CloseOut"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="downloads">
        <v-container class="input-wrapper" pa-0>
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">File Type</th>
                      <th class="text-left">Name</th>
                      <th class="text-left closeOut-file-type-header">Type</th>
                      <th class="text-right">Download</th>
                    </tr>
                  </thead>
                  <tbody v-if="files.length > 0">
                    <tr v-for="file in files" :key="file.fileId + '_' + file.category">
                      <td>{{file.category}}</td>
                      <td class="pr-0">{{file.fileName}}</td>
                      <td class="closeOut-file-type-cell">
                        <span v-if="file.type">
                          {{file.type}}
                        </span>
                        <span v-else>N/A</span>
                      </td>
                      <td><v-checkbox success style="float: right;" ref="checkBox" id="yesValue" @change="checked(file)"></v-checkbox></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="3" class="text-center"> No Documents Uploaded</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
        <div class="footer">
          <v-container pa-0>
            <v-row>
              <v-col class="spacing-col" cols="2"> </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12" class="btn-wrapper">
                <v-btn color="accent" class="btn-save" @click="download">
                  <v-progress-circular indeterminate
                                       color="accent" size="20" width="2" v-if="loading">
                  </v-progress-circular>
                  Download
                </v-btn>
                <v-checkbox success class="select-all" id="yesValue" label="Select All" @change="selectAll()"></v-checkbox>
              </v-col>
              <v-col class="spacing-col" cols="2"></v-col>
            </v-row>
          </v-container>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <v-snackbar v-model="showMessage" color="error">
      Failed to download zip folder
      <v-btn icon color="white" text @click="showMessage = false">
        <v-icon size="28">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import FileUpload from '@/components/files/FileUpload'
export default {
  name: 'CloseOut',
  components: {
    FileUpload
  },
  created () {
    const data = {}
    data.taskID = this.task.id
    data.archived = false
    if (this.task.dcmp !== "0001-01-01T00:00:00") {
         this.DCMP =  new Date(this.task.dcmp).toISOString().substr(0, 10)
    }
    if (this.task.cpa !== 0) {
        this.CPA = this.task.cpa
     }
     this.getFiles(data)
    },
    watch: {
    DCMP: {
      handler() {
        let updateDCMP = this.task
        updateDCMP.dcmp = this.DCMP
        this.update(updateDCMP)
      }
    },
    CPA: {
      handler() {
        let updateCPA = this.task
        updateCPA.cpa = this.CPA
        this.update(updateCPA)
      }
    }
  },
  data () {
    return {
      tab: 'details',
      documentIds: [],
      imageIds: [],
      changeIds: [],
      loading: false,
      showMessage: false,
      allSelected: false,
      selectMessage: 'Select All',
      calendarA: false,
      DCMP: null,
      CPA: 0,
      rules: {
        number: value => {
          const pattern = /^(([1-9]*)|(([1-9]*)\.([0-9]*)))$/
          return pattern.test(value) || 'Not a number'
        }
      }
    }
  },
  methods: {
    ...mapActions({
      zip: 'file/getZip',
      reset: 'file/reset',
      getFiles: 'file/getTaskFiles',
      update: 'workOrderTask/updateTask',
    }),
    async download () {
      this.reset()
      this.loading = true
      let data = {
        fileName: 'download.zip',
        docIds: this.documentIds,
        imageIds: this.imageIds,
        changeIds: this.changeIds
      }

      data.fileName = this.task.workOrder.workOrderNumber.replace(/\s+/g, '').toLowerCase() + '_' + this.task.taskNumber.replace(/\s+/g, '').toLowerCase() + '.zip'
      await this.zip(data)

      this.loading = false

      if (this.error != null) {
        this.showMessage = true
      }
    },
    async checked (file) {
      let alreadyChecked = false
      this.loading = false
      this.showMessage = false
      this.reset()
      //  Add to document id list
      if (file.category === 'Document') {
        this.documentIds.forEach((x, index) => {
          if (x === file.fileId) {
            alreadyChecked = true
            this.documentIds.splice(index, 1)
          }
        })
        if (!alreadyChecked) {
          this.documentIds.push(file.fileId)
        }
      }

      //  Add to image id list
      if (file.category === 'Image') {
        this.imageIds.forEach((x, index) => {
          if (x === file.fileId) {
            alreadyChecked = true
            this.imageIds.splice(index, 1)
          }
        })
        if (!alreadyChecked) {
          this.imageIds.push(file.fileId)
        }
      }

      // Add to change id list
      if (file.category === 'Change Request') {
        this.changeIds.forEach((x, index) => {
          if (x === file.fileId) {
            alreadyChecked = true
            this.changeIds.splice(index, 1)
          }
        })
        if (!alreadyChecked) {
          this.changeIds.push(file.fileId)
        }
      }
    },
    selectAll () {
      let documents = []
      let images = []
      let changes = []

      if (this.allSelected === false) {
        this.files.forEach((file) => {
          switch (file.category) {
            case 'Document':
              documents.push(file.fileId)
              break
            case 'Image':
              images.push(file.fileId)
              break
            case 'Change Request':
              changes.push(file.fileId)
              break
            default:
              // do nothing
          }
        })
        this.$refs['checkBox'].forEach((x) => {
          x.internalValue = true
        })
        this.selectMessage = 'Select None'
        this.allSelected = true
      } else if (this.allSelected === true) {
        this.$refs['checkBox'].forEach((x) => {
          x.internalValue = false
        })
        this.selectMessage = 'Select All'
        this.allSelected = false
      }

      this.documentIds = documents
      this.imageIds = images
      this.changeIds = changes
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      images: 'image/imagesByTask',
      documents: 'document/documentsByTask',
      changeOrders: 'changeOrder/changeOrdersByTask',
      error: 'file/error',
      success: 'file/success',
      files: 'file/filesByTask'
    })
  }
}
</script>
<style scoped>
::placeholder {
  color: rgba(0, 0, 0, 0.87) !important;
}
.input-card {
  border: 1px solid #e0e0e0 !important;
  border-radius: 0;
}
.input-wrapper {
  min-height: 280px;
  padding: 0;
}
.btn-wrapper {
  padding: 0 12px 16px 0 !important;
  margin-bottom: 16px;
}
.btn-save {
  float: right;
}
  .select-all {
    float: right;
    margin-right: 20px;
    margin-top: 0px !important;
  }
@media only screen and (max-width: 959px) {
  .input-wrapper {
    padding: 0 16px;
  }
  .btn-wrapper {
    padding-right: 28px !important;
  }
  .spacing-col {
    display: none;
  }
}
@media only screen and (max-width: 560px) {
  .closeOut-file-type-header,
  .closeOut-file-type-cell {
    display: none;
  }
}
@media only screen and (max-width: 420px) {
  .input-card {
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
  }
}
</style>
